export const isValidNumberAnatel = key => {
  if (key) {
    return key.replace(/\D/g, '').length === 12 && /^\d+$/.test(key)
  }
  return true
}
